import React from "react";
import { AddInfo } from ".";

function FloatRight() {
  return (
    <div>
      <AddInfo />
    </div>
  );
}

export default FloatRight;
